import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AppState } from '../app.service';

@Injectable({
  providedIn: "root",
})
export class FooziAiConciergeService {
  API_URL: string = environment.fooziBaseUrl
  CREATE_SESSION = '/chatHandler/generateSession'
  currentUser: any;
  path: any;
  SEND_MESSAGE = '/chatHandler/<session_id>/message'
  GET_SESSION = '/chatHandler/<session_id>'
  APP_API_URL = environment.apiBaseUrl
  LIKE_RESPONSE = '/like_response'
  DISLIKE_RESPONSE = '/dislike_response'
  isSessionExpired : BehaviorSubject<number> = new BehaviorSubject(0);
  getDocumentDetails ='/get_document_details'
  private isVisitedFooziComp = new BehaviorSubject<any>(null);
  private isHamburgerExpanded = new BehaviorSubject<any>(null);

  get expandHamburger() {
    return this.isHamburgerExpanded.asObservable();
  }
  get FooziCompStatus() {
    return this.isVisitedFooziComp.asObservable();
  }
  constructor(
    private http: HttpClient,
    private appState: AppState
  ) {}

  public createChatSession() : Observable<any> {
    this.currentUser = this.appState.get('currentUser')
    this.path = this.appState.get('currentPath')
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    const params = new HttpParams().set('userId', this.currentUser.id).set('pathId', this.path.id);
    return this.http.post(this.API_URL + this.CREATE_SESSION, params, {headers: headers});
  }

  public checkSessionValidity(session_id) : Observable<any> {
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    return this.http.get(this.API_URL + this.GET_SESSION.replace('<session_id>', session_id), {headers: headers});
  }

  public sendMessage(session_id, message) : Observable<any> {
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    return this.http.post(this.API_URL + this.SEND_MESSAGE.replace('<session_id>', session_id) + '?message=' + message, {}, {headers: headers}); 
  }

  public getPostID(postReplyID) {
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    const params_tmp = new HttpParams().set('id', postReplyID)
    return this.http.get(this.APP_API_URL + '/getPostRepliesDetails', {headers: headers, params: params_tmp});
  }
  
  public getPostReplies(postID, mode, path_id, reply_id?) {
    const headers = new HttpHeaders();
    const translate =this.appState.get('selectedLanguage')? true:false
    headers.set('Authorization', localStorage.getItem('token'));
    let params = new HttpParams().set('id', postID).set('mode', mode).set('routine_answer_id', 'undefined').set('page', '2').set('path_id', path_id).set('is_translate',translate);
    if (reply_id && reply_id !=undefined) {
      params = new HttpParams().set('id', postID).set('mode', mode).set('routine_answer_id', 'undefined').set('page', '1').set('path_id', path_id).set('reply_id', reply_id).set('is_translate',translate)
    }
    return this.http.get(this.APP_API_URL + '/get_posts_replies', {headers: headers, params: params});
  }


  public sendLike(response, prompt, feedback = '', like = 'true') {
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    const params = new HttpParams().append('response', response)
                                   .append('prompt', prompt)
                                   .append('feedback', feedback)
                                   .append('like', like);
    return this.http.post(this.APP_API_URL + this.LIKE_RESPONSE, params, {headers: headers});
  }

  fetchDocumentDetails(docId) {
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    const params = new HttpParams().set('doc_id', docId)
    return this.http.get(this.APP_API_URL + this.getDocumentDetails, {headers: headers, params: params});
  }
  setFooziCompStatus(val) {
    this.isVisitedFooziComp.next(val);
  }
  setExpandHamburger(val) {
    this.isHamburgerExpanded.next(val);
  }
  get sessionValidityStatus() {
    return this.isSessionExpired.asObservable();
  }
  setsessionValidityStatus(val) {
    this.isSessionExpired.next(val);
  }
}
